import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import Loading from '../../common/components/Loading/Loading';
import FeePanel from '../../common/components/FeePanel/FeePanel';
import Container from '../../common/components/Container/Container';
import TitleContainer from '../../common/components/TitleContainer/TitleContainer';
import ButtonContainer from '../../common/components/Button/ButtonContainer';
import Button, { ButtonStyle } from '../../common/components/Button/Button';
import SVGInfo from '../../common/assets/svg/icons/SVGInfo';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function TokenInReviewScreen(): JSX.Element {
  const { t } = useTranslation();
  const { chainName, networkName, ownerSignsEnabled } = useContext(FlowConfigContext);

  if (ownerSignsEnabled) {
    return (
      <Container>
        <TitleContainer center>
          <h1 data-testid="screens.signTransaction.title">
            {t('screens.signTransaction.title', { context: networkName })}
          </h1>
        </TitleContainer>

        <React.Suspense
          fallback={
            <div className="my-8">
              <Loading />
            </div>
          }
        >
          <FeePanel />
        </React.Suspense>

        <ButtonContainer>
          <Button style={ButtonStyle.DEFAULT} disabled loading dataTestid="OK_BUTTON" onClick={() => { }}>
            <span>{t('screens.signTransaction.buttonLabel', { context: networkName })}</span>
          </Button>
        </ButtonContainer>
        <div className="-mt-1 flex w-full transform flex-row items-center justify-center rounded-xl border border-border p-4">
          <SVGInfo />
          <div className="w-full text-left pl-2 leading-tight font-extralight text-sm">
            <span className="mt-2 break-normal">
              {t('screens.signTransaction.approveTransaction', { context: networkName })}
            </span>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <MessagePanel
      title="screens.tokenRefreshInReview.title"
      description="screens.tokenRefreshInReview.description"
      showLoading
      showSupportLink
    />
  );
}
export default withRouteAnalytics(TokenInReviewScreen, Screens.TOKEN_REFRESH_IN_REVIEW);
